import { render, staticRenderFns } from "./KitchenHeader.vue?vue&type=template&id=0cc04212&scoped=true"
import script from "./KitchenHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./KitchenHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./KitchenHeader.vue?vue&type=style&index=0&id=0cc04212&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc04212",
  null
  
)

export default component.exports